export default {
  native: [
    {
      name: 'Our Other Platforms',
      icon: 'reporting',
      url: 'goToNothingImportant',
      children: [
        {
          name: 'LanderLab',
          url: 'https://landerlab.io/?utm_campaign=optimizer_menu&cpid=64dfe122de76b90012195cc6',
          icon: 'manualConnection',
          external: true,
        },
        {
          name: 'ClickFlare',
          url: 'https://clickflare.io/?utm_campaign=optimizer_menu&cpid=63c058719097e90012994076',
          icon: 'manualUpdate',
          external: true,
        },
      ],
    },
    {
      title: true,
      name: 'DASHBOARD',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'dashboard',
    },
    {
      name: 'Campaigns',
      url: '/campaigns',
      icon: 'campaigns',
    },
    {
      title: true,
      name: 'AUTOMATION',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Campaign Creator',
      url: '/campaign-creator-queue',
      icon: 'campaignCreator',
    },
    {
      name: 'Media Manager',
      url: '/media-manager',
      icon: 'mediaManager',
      isUnleashProtected: true,
      children: [
        {
          name: 'Ads',
          url: '/media-manager/ads',
          icon: 'ad',
        },
        {
          name: 'Images',
          url: '/media-manager/images',
          icon: 'image',
        },
        {
          name: 'Headlines',
          url: '/media-manager/headlines',
          icon: 'headline',
        },
      ],
    },
    {
      name: 'Rules',
      url: '/rules',
      icon: 'rules',
    },
    // {
    //   name: 'Rules Old',
    //   url: '/rules-old',
    //   icon: 'icon-puzzle'
    // },
    {
      name: 'Smart Lists',
      url: '/smart-lists',
      icon: 'smartLists',
    },
    {
      title: true,
      name: 'ACCOUNTS',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Account Wizard',
      url: '/account-wizard',
      icon: 'accountWizard',
    },
    {
      name: 'Traffic Sources',
      url: '/traffic-sources',
      icon: 'trafficSources',
    },
    {
      name: 'Trackers',
      url: '/trackers',
      icon: 'trackers',
    },
    {
      title: true,
      name: 'TOOLS',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Manual Connection',
      url: '/manual-connection',
      icon: 'manualConnection',
    },
    {
      name: 'System Activity',
      url: '/system-activity',
      icon: 'dashboard',
    },
    {
      name: 'Reporting',
      url: '/reporting',
      icon: 'reporting',
    },
    {
      name: 'Manual Stats Update',
      url: '/manual-stats-update',
      icon: 'manualUpdate',
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'settings',
    },
    {
      title: true,
      name: 'HELP & SUPPORT',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Knowledge Base',
      url: 'https://theoptimizer.io/help',
      icon: 'info',
      external: true,
    },
    {
      name: 'FAQ',
      url: 'https://theoptimizer.io/help/knowledge-base/frequently-asked-questions-faq/',
      icon: 'faq',
      external: true,
    },
    // {
    //   name: 'Instructional Videos',
    //   url: 'https://support.theoptimizer.io/217026-Video-Guides---Connecting-your-tracker-and-traffic-source',
    //   icon: 'fa fa-film',
    //   external: true
    // },
    {
      name: 'Blog',
      url: 'http://blog.theoptimizer.io/',
      icon: 'blog',
      external: true,
    },
  ],
  mobile: [
    {
      name: 'Our Other Platforms',
      icon: 'reporting',
      url: 'goToNothingImportant',
      // badge: {
      //   variant: 'danger',
      //   text: 'NEW',
      // },
      children: [
        {
          name: 'TheOptimizer Pop/Push',
          url: '',
          icon: 'reporting',
          external: true,
        },
        {
          name: 'xOptimizer',
          url: '',
          icon: 'manualUpdate',
          external: true,
        },
        {
          name: 'LanderLab',
          url: '',
          icon: 'manualConnection',
          external: true,
        },
      ],
    },
    {
      title: true,
      name: 'DASHBOARD',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'dashboard',
    },
    {
      name: 'Campaigns',
      url: '/campaigns',
      icon: 'campaigns',
    },
    {
      title: true,
      name: 'AUTOMATION',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Rules',
      url: '/rules',
      icon: 'rules',
    },
    {
      title: true,
      name: 'ACCOUNTS',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Account Wizard',
      url: '/account-wizard',
      icon: 'accountWizard',
    },
    {
      name: 'Traffic Sources',
      url: '/traffic-sources',
      icon: 'trafficSources',
    },
    {
      name: 'Trackers',
      url: '/trackers',
      icon: 'trackers',
    },
    {
      title: true,
      name: 'TOOLS',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Manual Connection',
      url: '/manual-connection',
      icon: 'manualConnection',
    },
    {
      name: 'System Activity',
      url: '/system-activity',
      icon: 'dashboard',
    },
    {
      name: 'Reporting',
      url: '/reporting',
      icon: 'reporting',
    },
    {
      name: 'Manual Stats Update',
      url: '/manual-stats-update',
      icon: 'manualUpdate',
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'settings',
    },
    {
      title: true,
      name: 'HELP & SUPPORT',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Knowledge Base',
      url: 'https://support.theoptimizer.io/en/collections/3190288-theoptimizer-mobile',
      icon: 'info',
      external: true,
    },
    {
      name: 'FAQ',
      url: 'https://support.theoptimizer.io/en/articles/5679250-faq',
      icon: 'dashboard',
      external: true,
    },
    {
      name: 'Blog',
      url: 'http://blog.theoptimizer.io/',
      icon: 'blog',
      external: true,
    },
  ],
  tracker: [
    {
      name: 'Our Other Platforms',
      icon: 'reporting',
      url: 'goToNothingImportant',
      children: [
        {
          name: 'TheOptimizer Native',
          url: 'https://native.theoptimizer.io/',
          icon: 'reporting',
          external: true,
        },
        {
          name: 'TheOptimizer Pop/Push',
          url: 'https://mobile.theoptimizer.io/',
          icon: 'reporting',
          external: true,
        },
        {
          name: 'xOptimizer',
          url: 'https://app.xoptimizer.io/',
          icon: 'manualUpdate',
          external: true,
        },
        {
          name: 'LanderLab',
          url: 'https://landerlab.io/',
          icon: 'manualConnection',
          external: true,
        },
      ],
    },
    {
      title: true,
      name: 'DASHBOARD',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'dashboard',
    },
    {
      name: 'Reporting',
      url: '/reporting',
      icon: 'reporting',
    },
    {
      name: 'Campaigns',
      url: '/campaigns',
      icon: 'campaigns',
    },
    {
      title: true,
      name: 'ACCOUNTS',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Traffic Sources',
      url: '/traffic-sources',
      icon: 'trafficSources',
    },
    {
      name: 'Offers',
      url: '/offers',
      icon: 'smartLists',
    },
    {
      name: 'Landers',
      url: '/landers',
      icon: 'smartLists',
    },
    {
      name: 'Affiliate Networks',
      url: '/affiliate-networks',
      icon: 'smartLists',
    },
    {
      title: true,
      name: 'AUTOMATION',
      wrapper: {
        element: 'span',
        attributes: {},
      },
      class: 'text-center',
    },
    {
      name: 'Flows',
      url: '/flows',
      icon: 'fa fa-sitemap',
    },
  ],
};
